export type AdCopyModel = {
  cache_key: number,
  campaign_id?: number,
  copied_to_campaign?: boolean,
  copy_type: 'default' | 'digital' | 'editorial' | 'newspaper' | 'print' | 'signboards' | '',
  description?: string,
  id: number,
  order_item_id?: number,
  order_item_ad_copy_id?: number,
  review_status?: 'pending' | 'approved' | 'rejected',
  tagline?: string,
}

export type AdCopyRequestOptions = {}

const state = {
  campaign_id: undefined,
  copied_to_campaign: false,
  copy_type: '',
  description: '',
  id: null,
  order_item_ad_copy_id: undefined,
  order_item_id: undefined,
  review_status: null,
  tagline: '',
}

export const requiredFields = [
  { key: 'copy_type' },
]

export default state
